import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default _ref => {
  let {
    components,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, `Clear and concise reproduction instructions are important for us to be
able to triage your issue in a timely manner. Note that you can use
`, /*#__PURE__*/React.createElement("a", {
    href: "https://guides.github.com/features/mastering-markdown/",
    target: "_blank"
  }, `Markdown`), `  to format lists and code.`));
};